/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelMappingVendor.ts                 *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/mapping-vendor";

export class AutogenModelMappingVendor<RowType extends ModelRow> extends Endpoint<RowType, RowMappingVendorFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowMappingVendor extends ModelRow<RowMappingVendorFields> {
	constructor(values?: Partial<RowMappingVendorFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowMappingVendorFields {
	alk_map_api_1: string;
	alk_map_api_2: string;
	api_key: string;
	company_id: string;
	customer_number: string;
	descr: string;
	distance_profile: string;
	is_active: string;
	map_view: string;
	out_of_corridor_url: string;
	pos_update_minutes: number;
	traffic: string;
	url: string;
	vendor: string;
	weather: string;
	weather_url: string;
}

